module.exports = __webpack_public_path__ + "media/images/drivers/DEFAULT-c887006b7a889af290732e7eef091a09.jpg";